<template>
    <b-badge
        :variant="variant"
        class="supplier-verification-source-badge"
    >
        {{ label }}
    </b-badge>
</template>

<script>
import { BBadge } from 'bootstrap-vue'

export default {
    components: { BBadge },
    props: {
        source: {
            type: String,
            required: true,
            validator(value) {
                return ['supplier', 'reply'].includes(value)
            },
        },
    },
    computed: {
        variant() {
            return this.source === 'supplier' ? 'light-primary' : 'light-secondary'
        },
        label() {
            return this.source === 'supplier' ? 'Supplier space' : 'Supplier reply'
        },
    },
}
</script>
